// Deal pipeline stages + subscription plans, shared across the CRM UI.
export const DEAL_STAGES = [
  { value: "new", label: "New", color: "bg-brand-orange/15 text-brand-orange border-brand-orange/30", dot: "bg-brand-orange" },
  { value: "qualified", label: "Qualified", color: "bg-blue-100 text-blue-800 border-blue-200", dot: "bg-blue-500" },
  { value: "discovery", label: "Discovery", color: "bg-indigo-100 text-indigo-800 border-indigo-200", dot: "bg-indigo-500" },
  { value: "proposal", label: "Proposal", color: "bg-violet-100 text-violet-800 border-violet-200", dot: "bg-violet-500" },
  { value: "negotiation", label: "Negotiation", color: "bg-amber-100 text-amber-800 border-amber-200", dot: "bg-amber-500" },
  { value: "follow_up", label: "Follow Up", color: "bg-teal-100 text-teal-800 border-teal-200", dot: "bg-teal-500" },
  { value: "revisit", label: "Revisit in the Future", color: "bg-sky-100 text-sky-800 border-sky-200", dot: "bg-sky-500" },
  { value: "won", label: "Won", color: "bg-emerald-100 text-emerald-800 border-emerald-200", dot: "bg-emerald-500" },
  { value: "lost", label: "Lost", color: "bg-zinc-100 text-zinc-700 border-zinc-200", dot: "bg-zinc-400" },
  { value: "not_interested", label: "Not Interested", color: "bg-rose-100 text-rose-800 border-rose-200", dot: "bg-rose-500" },
  { value: "ac_customer", label: "AC Customer", color: "bg-lime-100 text-lime-800 border-lime-200", dot: "bg-lime-500" },
];

export const SUBSCRIPTION_PLANS = [
  { value: "essential", label: "Essential" },
  { value: "pro", label: "Pro" },
  { value: "enterprise", label: "Enterprise" },
];

export const SERVICE_GROUPS = [
  "Catering",
  "Food Hygiene Inspection",
  "FSSC",
  "FSSC Consultancy",
  "GMP",
  "HACCP",
  "ISO Consultancy",
  "SFA License",
];

export function getStageMeta(value) {
  return DEAL_STAGES.find((s) => s.value === value) || DEAL_STAGES[0];
}

export function getPlanMeta(value) {
  return SUBSCRIPTION_PLANS.find((p) => p.value === value);
}

export function formatSGD(n) {
  if (n == null || Number.isNaN(Number(n))) return "S$0";
  const v = Number(n);
  // Show cents only when the amount actually has a fractional part.
  const hasCents = Math.abs(v - Math.trunc(v)) > 0.0001;
  return `S$${v.toLocaleString(undefined, {
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2,
  })}`;
}
